module.exports = __webpack_public_path__ + "static/media/Rectangle 189.4b652379.svg";